function readValue(row, keys) {
  row = row || {}
  for (var i = 0; i < keys.length; i++) {
    var value = row[keys[i]]
    if (value !== undefined && value !== null && value !== '') return value
  }
  return ''
}

module.exports = {
  props: {
    productMode: {
      type: String,
      default: 'single',
      validator: function (value) {
        return ['single', 'multiple'].indexOf(value) > -1
      }
    }
  },
  data: function () {
    return {
      productRows: [],
      activeProductRow: {},
      productListLoading: false,
      productSwitching: false,
      productRequestId: 0
    }
  },
  computed: {
    isMultipleProductMode: function () {
      return this.productMode === 'multiple'
    },
    effectiveOrderRow: function () {
      if (this.productMode !== 'multiple' || !this.activeProductRow || !Object.keys(this.activeProductRow).length) {
        return this.orderRow || {}
      }
      return Object.assign({}, this.orderRow || {}, this.activeProductRow)
    }
  },
  methods: {
    getProductOrderNo: function () {
      return readValue(this.orderRow, ['REFIDNO', 'refidno', 'ORDNO', 'ordno', 'IDNO', 'idno'])
    },
    getProductCorpid: function () {
      return readValue(this.orderRow, ['CORPID', 'corpid']) || this.$cookies.get('v_corpid') || ''
    },
    getProductKey: function (row) {
      return String(readValue(row, ['IDSEQ', 'idseq'])) + '::' + String(readValue(row, ['LSTSEQ', 'lstseq']))
    },
    getProductLabel: function (row) {
      return [readValue(row, ['MATNO', 'matno']), readValue(row, ['MATNM', 'matnm'])]
        .filter(function (value) { return value })
        .join(' ')
    },
    normalizeProductRows: function (rows) {
      return (Array.isArray(rows) ? rows : []).map(function (row) {
        return Object.assign({}, row, {
          IDSEQ: readValue(row, ['IDSEQ', 'idseq']),
          LSTSEQ: readValue(row, ['LSTSEQ', 'lstseq']),
          MATNO: readValue(row, ['MATNO', 'matno']),
          MATNM: readValue(row, ['MATNM', 'matnm']),
          CORPID: readValue(row, ['CORPID', 'corpid'])
        })
      }).filter(function (row) {
        return row.IDSEQ !== '' && row.LSTSEQ !== ''
      }).sort(function (left, right) {
        return Number(left.LSTSEQ) - Number(right.LSTSEQ)
      })
    },
    loadProductRows: function () {
      var orderNo = this.getProductOrderNo()
      var corpid = this.getProductCorpid()
      if (!orderNo) return Promise.reject(new Error('当前任务未关联销售订单'))
      return this.loadTableRows(
        'V_ORDITM_QRY', 'ORDNO', orderNo, 'CORPID', corpid, '', '', ' and lower(matno) like \'s%\' order by LSTSEQ'
      ).then(this.normalizeProductRows.bind(this))
    },
    beginProductRequest: function () {
      this.productRequestId += 1
      return this.productRequestId
    },
    isCurrentProductRequest: function (requestId) {
      return requestId === this.productRequestId
    },
    activateFirstProduct: function () {
      this.activeProductRow = this.productRows.length ? this.productRows[0] : {}
      return this.activeProductRow
    },
    selectProductByKey: function (key) {
      if (this.productSwitching || key === this.getProductKey(this.activeProductRow)) {
        return Promise.resolve(false)
      }
      var nextRow = this.productRows.filter(function (row) {
        return this.getProductKey(row) === key
      }.bind(this))[0]
      if (!nextRow) return Promise.resolve(false)

      var previousRow = this.activeProductRow
      var requestId = this.beginProductRequest()
      this.activeProductRow = nextRow
      this.productSwitching = true
      return this.reloadFishboneForActiveProduct().then(function () {
        return this.isCurrentProductRequest(requestId)
      }.bind(this)).catch(function (error) {
        if (!this.isCurrentProductRequest(requestId)) return false
        this.activeProductRow = previousRow
        throw error
      }.bind(this))
        .finally(function () {
          if (this.isCurrentProductRequest(requestId)) this.productSwitching = false
        }.bind(this))
    },
    resetProductModeState: function () {
      this.productRequestId += 1
      this.productRows = []
      this.activeProductRow = {}
      this.productListLoading = false
      this.productSwitching = false
    }
  }
}
